import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useFormContext } from 'react-hook-form';
import get from 'lodash.get';
import { MultiSelect } from 'services/Main/types.Field';
import MultiSelectInput from '../components/MultiSelectInput';
import Tags from '../components/Tags';
import useStyles from '../Select.styles';
import { useFormatMessage } from '../../../../locale';

interface OtherProps {
  value?: any;
  onChange?: any;
}

export default ({
  disabled,
  options,
  label,
  value,
  name,
  helperText,
  onChange,
  highlightColor,
}: MultiSelect & OtherProps) => {
  const classes = useStyles(highlightColor)();
  const formatMessage = useFormatMessage();
  const { errors } = useFormContext();
  const error = get(errors, name);
  const handleChange = (event: any, values: any) => {
    onChange(values);
  };

  return (
    <Autocomplete
      className={classes.autocompleteRoot}
      multiple
      noOptionsText={formatMessage('noOptions')}
      clearText={formatMessage('clear')}
      closeText={formatMessage('close')}
      openText={formatMessage('open')}
      classes={{
        loading: 'animate-flicker',
      }}
      disabled={disabled}
      value={value || []}
      getOptionLabel={(option) => option.label}
      getOptionSelected={(o, v) => o.value === v.value}
      getOptionDisabled={(o) => o.disabled}
      options={options}
      onChange={handleChange}
      disableCloseOnSelect
      renderInput={(params) => (
        <MultiSelectInput
          params={params}
          name={name}
          error={error}
          helperText={error?.message || helperText}
          value={value}
          label={label}
          highlightColor={highlightColor}
        />
      )}
      renderTags={(tagValue) => <Tags tagValue={tagValue} />}
    />
  );
};
